import { Pagination } from 'react-bootstrap';
const ProductPagination = (props) => {
  const {
    size = 0,
    current,
    setPage = () => { },
    style = {},
    handleClick = () => { }
  } = props

  let parsedPag = []


  parsedPag = size < 5 ? Array(size).fill(1).map((_, i) =>
    <Pagination.Item
      key={i}
      onClick={() => handleClick(i + 1)}
      active={current === i + 1}>{i + 1}</Pagination.Item>
  ) :
    <Pagination.Item
      onClick={() => { }}
      active={true}>{current}</Pagination.Item>

  return (

    <div className='pagination-container'>
      {size ?
        <Pagination
        >
          {
            size > 3 &&
            <Pagination.First onClick={() => handleClick(1)} />
          }
          <Pagination.Prev onClick={() => {
            if (current > 1) {
              handleClick(current - 1);
              // setPage(current - 1);
              // cb(current - 1)
            }
          }} />
          {parsedPag}
          <Pagination.Next onClick={() => {
            if (current < size) {
              handleClick(current + 1);
              // setPage(current + 1);
              // cb(current + 1)
            }
          }
          }
          />
          {
            size > 3 &&
            <Pagination.Last onClick={() => handleClick(size)} />
          }
        </Pagination>

        : <Pagination>
          <Pagination.Item>1</Pagination.Item>
        </Pagination>
      }
    </div>
  )

}
export default ProductPagination;